<template>
    <div class="section-tag-card">
        <div class="section-tag-card__picture">
            <a :href="result.LINK" class="section-tag-card__header">
                <DefImg
                        v-if="result.picture"
                        :result="result.picture"
                />
                <!--            <img :src="result.picture.src" :alt="result.picture.alt" class="def-img">-->
            </a>
        </div>

        <p>{{ result.TEXT }}</p>
    </div>
</template>

<script>
    import DefImg from "../../Def/DefImg/DefImg.vue";

    export default {
        name: 'SectionTagCard',
      components: {DefImg},
        props: ['result'],
    }
</script>

<style lang="scss" scoped>
    .section-tag-card{
        font-size: 14px;
        font-style: normal;
        /*font-weight: 600;*/
        line-height: 17px;
        letter-spacing: 0;
        text-align: center;
        width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 5px;
        box-sizing: content-box;
        &__picture {
            display: flex;
            flex-direction: column;
            position: relative;
            justify-content: center;
            align-items: center;
            padding: 2px;
            height: 115px;
            width: 115px;
            overflow: hidden;
            margin: 0 auto;
            border-radius: 50%;
            border: 2px solid black;
            /*background: linear-gradient(105deg, rgb(0, 0, 0), rgb(0, 0, 0));*/
            /*border-radius: 115px;*/
        }

        &:hover{
            /*:deep(.def-img){*/
            /*    transform: scale(1.1);*/
            /*}*/
        }
        &__header{
            overflow: hidden;
        }
        &__description{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 8px;
            font-weight: 600;
            font-size: rem(12);
            text-transform: uppercase;
        }
        &__label{
            padding: 4px 6px;
            @include point-md{
                color: var(--color-dark-grey);
            }
        }
        &__created{
            color: var(--color-dark-grey);
        }
        &__footer{
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            padding-top: 16px;
        }
        &__name{
            font-weight: 600;
            font-size: rem(14);
            line-height: 125%;
            margin-bottom: 24px;
            transition: .2s linear color;
            @include point-md{
                font-size: rem(16);
                line-height: 135%;
                margin-bottom: 22px;
            }
            &:hover{
                color: var(--color-link-hover-dark);
            }
        }
        :deep(.def-link){
            margin-top: auto;
            font-weight: 500;
            font-size: rem(12);
        }
        :deep(.def-img){
            transform-origin: center;
            /*transition: .2s linear transform;*/
            /*display: block;*/
            /*height: auto;*/
            /*width: 100%;*/

            max-width: 100%;
            position: relative;
            border-radius: 100px;
            height: 109px;
            width: 109px;
            margin: 0;
            transition: .2s;
            object-fit: cover;
            border: 5px solid #fff;
        }
    }
</style>